import merge from 'deepmerge';
import { useEffect } from 'react';
import ModalComponent from 'react-modal';

export const Modal = ({
    isOpen,
    closeModal,
    children,
    shouldCloseOnOverlayClick = true,
    ariaHideApp,
    disableScrolling,
    style,
    zIndex = '1100',
}: {
    isOpen: boolean;
    closeModal?: () => void;
    children: React.ReactNode;
    shouldCloseOnOverlayClick?: boolean;
    ariaHideApp?: boolean;
    disableScrolling?: boolean;
    style?: any;
    zIndex?: string;
}) => {
    const modalStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            padding: '0',
            transform: 'translate(-50%, -50%)',
            border: '0',
        },
        overlay: {
            zIndex: style?.zIndex || zIndex || '1100',
            backgroundColor: 'rgba(0, 3, 16, 0.2)',
        },
    };

    const onRequestCloseHandler = (event: React.MouseEvent<HTMLElement>) => {
        document.body.style.overflow = 'unset';
        closeModal && closeModal();
        onClickHandler(event);
    };

    const onClickHandler = (event: React.MouseEvent<HTMLElement>) => {
        if (event?.stopPropagation) event.stopPropagation();
        if (event?.nativeEvent?.stopImmediatePropagation) event.nativeEvent.stopImmediatePropagation();
    };

    useEffect(() => {
        if (document.getElementById('root')) {
            ModalComponent.setAppElement('#root');
        }
        if (disableScrolling && isOpen) {
            document.body.style.overflow = 'hidden';
        }
        if (!isOpen || !disableScrolling) document.body.style.overflow = 'unset';
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    return (
        <>
            {isOpen && (
                <div onClick={onClickHandler}>
                    <ModalComponent
                        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
                        onRequestClose={onRequestCloseHandler}
                        isOpen={isOpen}
                        style={style ? merge(modalStyles, style) : modalStyles}
                        ariaHideApp={ariaHideApp}
                        preventScroll={disableScrolling}
                    >
                        <div>{children}</div>
                    </ModalComponent>
                </div>
            )}
        </>
    );
};
